export default __webpack_public_path__ + "static/media/pairs-collapse.32a2d899.svg";